"use client";
import React from "react";

export const ContactForm = () => {
    const submitForm = (e: any) => {
        e.preventDefault();
        const formData: any = Object.fromEntries(new FormData(e.target));
        try {
            const WEBHOOK =
                "https://discord.com/api/webhooks/1117765814242791445/-FrUZ2b1walNMViWqupLSV4H99kOjOtMvIM3Xw_8IsQ4BUqYcMDKoGh6eqgQ7amov6jN";
            const data = {
                embeds: [
                    {
                        title: "Contact Form",
                        color: 0x0099ff,
                        fields: [
                            {
                                name: "Nume",
                                value: formData.fullName.toString(),
                            },
                            {
                                name: "Telefon",
                                value: formData.phone.toString(),
                            },
                            {
                                name: "Mesaj",
                                value: formData.message.toString(),
                            },
                        ],
                        timestamp: new Date().toISOString(),
                    },
                ],
            };

            fetch(WEBHOOK, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
        } catch (err: any) {
            console.log(err.message);
        } finally {
            e.target.reset();
        }
    };
    return (
        <form onSubmit={submitForm}>
            <div className="flex flex-col md:flex-row">
                <input
                    id="fullName"
                    name="fullName"
                    placeholder="Nume"
                    type="text"
                    className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none md:mr-2 focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                />
                <input
                    placeholder="Telefon"
                    id="phone"
                    name="phone"
                    type="phone"
                    className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none md:mr-2 focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="flex items-center mt-4 w-full">
                <input
                    placeholder="Mesaj"
                    id="message"
                    name="message"
                    type="text"
                    className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none md:mb-0 focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="flex items-center mt-4 w-full">
                <button
                    type="submit"
                    className="inline-flex items-center justify-center h-12 px-6 mr-2 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none flex-grow"
                >
                    Trimite!
                </button>
            </div>
        </form>
    );
};
